import { css } from '@/styled-system/css';

export const dashboardHeaderContainerStyles = css.raw({
  backgroundColor: 'bg.neutral',
  borderBottomWidth: 'default',
  borderBottomStyle: 'solid',
  borderBottomColor: 'border.muted',
});

export const dashboardHeaderContentStyles = css.raw({
  marginBlock: '0',
  paddingTop: { base: '400', md: '800' },
  paddingInline: '400',
});

export const dashboardBodyContentStyles = css.raw({
  marginBlockStart: '400',
  paddingInline: '400',
});
